import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LocaleContext } from 'routes/Router';
import ArrowLeftIcon from 'assets/images/WithoutLogin/arrow-left.svg';
import DefaultImage from 'assets/images/Dashboard/default-list.svg';
import CallIcon from 'assets/images/Dashboard/call.svg';
import MailIcon from 'assets/images/Dashboard/mail.svg';
import HospitalIcon from 'assets/images/Dashboard/doctor-hospital.svg';
import VideoCallCameraIcon from 'assets/images/Dashboard/Video_Call.svg';
import ClockIcon from 'assets/images/Dashboard/clock.svg';
import CalerderIcon from 'assets/images/Dashboard/calendar.svg';
import { getAppointmentDetail } from 'store/getAppointmentDetail/getAppointmentDetailAcition';
import { ClearTokenRedirectLogin } from 'utils/general';
import moment from 'moment';
import EditMedicine from 'assets/images/Dashboard/edit-pending.svg';
import DeleteMedicine from 'assets/images/Dashboard/delete-pending.svg';
import ReusableButton from 'components/commom/Button';
import AddIcon from 'assets/images/Dashboard/add-medicin-icon.svg';
import CommonModal from 'components/commom/Modal';
import LabelWithInput from 'components/commom/LabelWithInput';
import LabelWithTextArea from 'components/commom/LabelWithTextArea';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from 'assets/images/Dashboard/search-pending.svg';
import { postPendig } from 'store/createPendingDetail/createPendingDetailAction';
import { doctorAppointments } from 'routes/AppUrls';
import { getProductList } from 'store/productList/productListAction';
import { Dialog, DialogContent } from '@mui/material';
import Shimmer from 'components/commom/Shimmer';
import MuiBreadcrumbs from 'components/commom/MuiBreadcrumbs';
import CommonToast from 'components/commom/CommonToast';
import TabSwitch from 'components/commom/SwitchLabelInput';
import CheckValidation from 'utils/validate';

const PendingDetail = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const dispatch = useDispatch();
  const { locale } = useContext(LocaleContext);
  const [appointmentPendingDetail, setAppointmentPendingDetail] = useState('');
  const { showToast } = CommonToast();
  const [medicineModal, setMedicineModal] = useState(false);
  const [adviceModal, setAdviceModal] = useState(false);
  const [followUpDate, setFollowUpDate] = useState('');
  const [productModal, setProductModal] = useState(false);
  const [diagnosisModal, setDiagnosisModal] = useState(false);
  const [adviceText, setAdviceText] = useState('');
  const [adviceTextShow, setAdviceTextShow] = useState('');
  const [medicinDetail, setMedicinDetail] = useState([]);
  const [formData, setFormData] = useState({
    medication_name: '',
    medicine_form: '',
    dosage: '',
    duration: '',
    is_substitute: '',
  });
  const [editIndex, setEditIndex] = useState(null);
  const [diagnosisDetail, setDiagnosisDetail] = useState([]);
  const [editIndexDiagnosis, setEditIndexDiagnosis] = useState(null);
  const [formValue, setFormValue] = useState({
    diagnosis_finding: '',
  });
  const [productDetail, setProductDetail] = useState([]);
  const [showProductList, setShowProductList] = useState([]);
  const [showProductListItem, setShowProductListItem] = useState([]);
  const [showProductId, setShowProductId] = useState([]);
  const [searchInput, setSearchInput] = useState('');

  const [isRepeatPrescription, setIsRepeatPrescription] = useState(false);
  const [repeatNotes, setRepeatNotes] = useState('');
  const [isError, setIsError] = useState(false);

  const pendingReducer = useSelector(
    (state) => state?.postPendingReducer?.loading
  );

  const appointmentDetailReducer = useSelector(
    (state) => state?.getAppointmentDetailReducer?.loading
  );

  const pendingId = useSelector(
    (state) => state?.basicDetailsValueReducer?.pendingId
  );

  const breadcrumbsList = [
    {
      title: <FormattedMessage id="Appointments" />,
      Link: '',
      isDisbale: true,
    },
    {
      title: <FormattedMessage id="Generate Diagnosis Report" />,
      Link: '',
      isDisbale: false,
    },
  ];

  useEffect(() => {
    getPendingDetail();
    getRecommendProductList();
  }, []);

  const getPendingDetail = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setAppointmentPendingDetail(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getAppointmentDetail(external, pendingId));
  };

  const handleAddMedicine = (medicine = null, index = null) => {
    setMedicineModal(true);
    setEditIndex(index);
    if (medicine) {
      setFormData({
        medication_name: medicine?.medication_name || '',
        medicine_form: medicine?.medicine_form || '',
        dosage: medicine?.dosage || '',
        duration: medicine?.duration || '',
        is_substitute: medicine?.is_substitute || '',
      });
    } else {
      setFormData({
        medication_name: '',
        medicine_form: '',
        dosage: '',
        duration: '',
        is_substitute: '',
      });
    }
  };
  const handleDeleteMedicine = (index) => {
    const updatedMedicineList = medicinDetail.filter((_, i) => i !== index);
    setMedicinDetail(updatedMedicineList);
  };

  const handleCloseMedicine = () => {
    setMedicineModal(false);
    setIsError(false);
  };

  const handleInputChange = (event, name) => {
    setFormData((prev) => ({
      ...prev,
      [name]: event?.target?.value,
    }));
  };

  const handleSaveMedicine = () => {
    const error = CheckValidation({
      medication_name: formData?.medication_name,
      medicine_form: formData?.medicine_form,
      dosage: formData?.dosage,
      duration: formData?.duration,
    });
    setIsError(error);
    if (error.submit) {
      let valueMedicine = [...medicinDetail];

      if (editIndex !== null) {
        valueMedicine[editIndex] = {
          medication_name: formData?.medication_name,
          medicine_form: formData?.medicine_form,
          dosage: formData?.dosage,
          duration: formData?.duration,
          is_substitute: formData?.is_substitute,
        };
      } else {
        valueMedicine.push({
          medication_name: formData?.medication_name,
          medicine_form: formData?.medicine_form,
          dosage: formData?.dosage,
          duration: formData?.duration,
          is_substitute: formData?.is_substitute,
        });
      }

      setMedicinDetail(valueMedicine);
      setMedicineModal(false);
      setEditIndex(null);
    }
  };

  const handleAdvice = () => {
    setAdviceModal(true);
  };

  const handleCloseAdvice = () => {
    setAdviceModal(false);
    setIsError(false);
  };

  const handleAdviceShow = () => {
    const error = CheckValidation({
      adviceText,
    });
    setIsError(error);
    if (error.submit) {
      setAdviceTextShow(adviceText);
      setAdviceModal(false);
    }
  };

  const handleAddProduct = () => {
    setProductModal(true);
  };

  const handleCloseProduct = () => {
    setProductModal(false);
    setShowProductList([]);
    setShowProductId([]);
  };

  const handleAddDiagnosis = (value = null, index = null) => {
    setDiagnosisModal(true);
    setEditIndexDiagnosis(index);
    if (value) {
      setFormValue({
        diagnosis_finding: value?.diagnosis_finding || '',
      });
    } else {
      setFormValue({
        diagnosis_finding: '',
      });
    }
  };

  const handleCloseDiagnosis = () => {
    setDiagnosisModal(false);
    setIsError(false);
  };

  const handleInputDiagnosisChange = (event, name) => {
    setFormValue((prev) => ({
      ...prev,
      [name]: event?.target?.value,
    }));
  };

  const handleSaveDiagnosis = () => {
    const error = CheckValidation({
      diagnosis_finding: formValue?.diagnosis_finding,
    });
    setIsError(error);
    if (error.submit) {
      let valueDiagnosis = [...diagnosisDetail];

      if (editIndexDiagnosis !== null) {
        valueDiagnosis[editIndexDiagnosis] = {
          diagnosis_finding: formValue?.diagnosis_finding,
        };
      } else {
        valueDiagnosis.push({
          diagnosis_finding: formValue?.diagnosis_finding,
        });
      }

      setDiagnosisDetail(valueDiagnosis);
      setDiagnosisModal(false);
      setEditIndexDiagnosis(null);
    }
  };

  const handleDeleteDiagnosis = (index) => {
    const updatedDiagnosisList = diagnosisDetail.filter((_, i) => i !== index);
    setDiagnosisDetail(updatedDiagnosisList);
  };

  const getRecommendProductList = (value) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setProductDetail(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getProductList(external, value));
  };

  const handleSearchInput = (event) => {
    setSearchInput(event?.target?.value);
    getRecommendProductList(event?.target?.value);
  };

  const handleSelectProduct = (value) => {
    let arr = [...showProductId];
    let arrList = [...showProductList];
    if (arr.includes(value?.node?.id)) {
      let index = arr.findIndex((item) => item === value?.node?.id);
      let indexList = arrList.findIndex((item) => item === value);
      arr.splice(index, 1);
      arrList.splice(indexList, 1);
      setShowProductList(arrList);
      setShowProductId(arr);
    } else {
      arr.push(value?.node?.id);
      arrList.push({
        product_image: value?.node?.featuredMedia?.preview?.image?.url,
        product_name: value?.node?.title,
        product_category_name: value?.node?.category?.name,
        product_price: value?.node?.variants?.edges?.[0]?.node?.price,
        product_id: value?.node?.id,
      });
    }
    setShowProductList(arrList);
    setShowProductId(arr);
  };

  const handleAddProductList = () => {
    setShowProductListItem(showProductList);
    setProductModal(false);
  };

  const handleDeleteProductList = (index) => {
    const updatedProductList = showProductListItem.filter(
      (_, i) => i !== index
    );
    setShowProductListItem(updatedProductList);
  };

  const handleCreateDetail = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        navigate(doctorAppointments(locale));
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    let body = {
      consultation_id: pendingId,
      follow_up_date: followUpDate,
      advice: adviceText,
      medicines: medicinDetail,
      diagnosis_list: diagnosisDetail,
      product_list: showProductListItem?.map(
        ({ product_id, product_name }) => ({
          product_id,
          product_name,
        })
      ),
      is_repeat: isRepeatPrescription,
      repeat_text: repeatNotes,
    };
    dispatch(postPendig(external, body));
  };

  const switchInput = [
    { id: false, name: 'No' },
    { id: true, name: 'Yes' },
  ];

  const handleCheckboxChange = (e, name, id) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: id?.id,
    }));
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <MuiBreadcrumbs size="12" list={breadcrumbsList} />
          <div className="mt-10">
            <Row className="bc-FFFFFF m-0 p-24 border-1 bColor-EFE3D7 m-0">
              <Col lg={12} className="p-0">
                <Stack direction="horizontal" gap={2} className="items-center">
                  <img
                    src={ArrowLeftIcon}
                    alt="icon"
                    style={{ height: '24px', width: '24px' }}
                    className="cursor-pointer"
                    onClick={() => navigate(-1)}
                  />
                  <div className="fs-20 lh-252 fc-292D32 family_outfit_semiBold_600">
                    <FormattedMessage id="Generate Diagnosis Report" />
                  </div>
                </Stack>
              </Col>
              <Col lg={12}>
                <div className="fs-14 lh-16 pt-8 pl-18 pb-16 fc-998A7B family_outfit_regular_400">
                  {appointmentDetailReducer ? (
                    <Shimmer width="250px" height="20px" />
                  ) : (
                    <>
                      <FormattedMessage id="Appointment no." />
                      {appointmentPendingDetail?.booking_id}
                    </>
                  )}
                </div>
              </Col>
              <Col md={5} className="p-0">
                <Stack direction="horizontal" gap={2} className="items-center">
                  {appointmentDetailReducer ? (
                    <Shimmer width="88px" height="88px" borderRadius="50%" />
                  ) : (
                    <Image
                      src={
                        appointmentPendingDetail?.patient?.profile_pic !== ''
                          ? appointmentPendingDetail?.patient?.profile_pic
                          : DefaultImage
                      }
                      alt="icon"
                      style={{
                        height: '88px',
                        width: '88px',
                        borderRadius: '50%',
                      }}
                    />
                  )}
                  <div>
                    <div className="fs-18 lh-2268 fc-202224 family_outfit_medium_500">
                      {appointmentDetailReducer ? (
                        <Shimmer width="150px" height="20px" />
                      ) : (
                        appointmentPendingDetail?.patient?.full_name
                      )}
                    </div>
                    <div className="pt-8 fs-14 fc-998A7B family_outfit_regular_400">
                      ID:
                      <span className="fc-3C3C3C family_outfit_medium_500">
                        {appointmentPendingDetail?.patient?.patient_id}
                      </span>
                    </div>
                  </div>
                </Stack>
              </Col>
              <Col md={7}>
                <Row>
                  <Col md={6} className="p-0">
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center"
                    >
                      {appointmentDetailReducer ? (
                        <Shimmer width="250px" height="20px" />
                      ) : (
                        <>
                          <Image src={CallIcon} alt="icon" />
                          <div className="fs-16 lh-201 family_outfit_regular_400 fc-202224">
                            {`${appointmentPendingDetail?.patient?.country_code} ${appointmentPendingDetail?.patient?.contact_number}`}
                          </div>
                        </>
                      )}
                    </Stack>
                  </Col>
                  <Col md={6}>
                    <Stack
                      direction="horizontal"
                      gap={1}
                      className="flex items-center"
                    >
                      <div className="fs-16 lh-201 fc-998A7B family_outfit_regular_400">
                        Modality:
                      </div>
                      <div>
                        <img
                          src={
                            appointmentPendingDetail?.consultation_type ===
                            'Hospital Visit'
                              ? HospitalIcon
                              : VideoCallCameraIcon
                          }
                          alt="icon"
                        />
                      </div>
                      <div className="fs-16 lh-201 fc-292D32 family_outfit_medium_500">
                        {appointmentDetailReducer ? (
                          <Shimmer width="100px" height="20px" />
                        ) : (
                          appointmentPendingDetail?.consultation_type
                        )}
                      </div>
                    </Stack>
                  </Col>
                  <Col md={6} className="p-0">
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center pt-24"
                    >
                      {appointmentDetailReducer ? (
                        <Shimmer width="100px" height="20px" />
                      ) : (
                        <>
                          <Image src={MailIcon} alt="icon" />
                          <div className="fs-16 lh-201 family_outfit_regular_400 fc-202224 break-words ...">
                            {appointmentPendingDetail?.patient?.email}
                          </div>
                        </>
                      )}
                    </Stack>
                  </Col>
                  <Col md={6}>
                    <Stack
                      direction="horizontal"
                      gap={5}
                      className="items-center pt-24"
                    >
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        {appointmentDetailReducer ? (
                          <Shimmer width="100px" height="20px" />
                        ) : (
                          <>
                            <Image src={CalerderIcon} alt="icon" />
                            <div className="fs-16 lh-201 fc-292D32 family_outfit_medium_500">
                              {moment(
                                appointmentPendingDetail?.appointment_date_time
                              ).format('MMMM D, YYYY')}
                            </div>
                          </>
                        )}
                      </Stack>
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        {appointmentDetailReducer ? (
                          <Shimmer width="100px" height="20px" />
                        ) : (
                          <>
                            <Image src={ClockIcon} alt="icon" />
                            <div className="fs-16 lh-201 fc-292D32 family_outfit_medium_500">
                              {moment(
                                appointmentPendingDetail?.appointment_date_time
                              ).format('hh:mmA')}
                            </div>
                          </>
                        )}
                      </Stack>
                    </Stack>
                  </Col>
                </Row>
              </Col>

              <Col md={12} className="p-0">
                <div className="fs-20 pt-24 lh-252 fc-292D32 family_outfit_semiBold_600">
                  Report
                </div>
              </Col>
              <Col md={12} className="p-0">
                <div className="fs-17 lh-21 pt-24 fc-292D32 family_outfit_medium_500">
                  Diagnosis
                </div>
              </Col>
              <Col md={4} className="p-0">
                {diagnosisDetail &&
                  diagnosisDetail.length > 0 &&
                  diagnosisDetail.map((item, index) => {
                    return (
                      <div className="m-0 p-12 mt-3 border-1 bColor-EFE3D7">
                        <div className="flex justify-between">
                          <div className="fs-14 lh-16 fc-3C3C3C family_outfit_regular_400">
                            {item?.diagnosis_finding}
                          </div>
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center cursor-pointer ..."
                          >
                            <div>
                              <Image
                                src={EditMedicine}
                                alt="icon"
                                onClick={() => handleAddDiagnosis(item, index)}
                              />
                            </div>
                            <div>
                              <Image
                                src={DeleteMedicine}
                                alt="icon"
                                onClick={() => handleDeleteDiagnosis(index)}
                              />
                            </div>
                          </Stack>
                        </div>
                      </div>
                    );
                  })}
              </Col>
              <Row className="">
                <Col md={8} className="p-0">
                  <div className="m-0 pt-16">
                    <ReusableButton
                      fullWidth={false}
                      variant="outlined"
                      color="#375241"
                      fontSize="14px"
                      fontWeight="500"
                      padding="12px 25px"
                      height="40px"
                      bgColor="transparent"
                      brColor="#375241"
                      fontFamily="outfit_medium"
                      onClick={() => handleAddDiagnosis()}
                    >
                      <img
                        src={AddIcon}
                        alt="icon"
                        style={{ height: '24px', width: '24px' }}
                        className="me-2"
                      />
                      <FormattedMessage id="Add Diagnosis" />
                    </ReusableButton>
                  </div>
                </Col>
              </Row>
              <Col md={12} className="p-0">
                <div className="fs-17 lh-21 pt-16 fc-292D32 family_outfit_medium_500">
                  Medicine (Rx)
                </div>
              </Col>
              {medicinDetail &&
                medicinDetail.length > 0 &&
                medicinDetail.map((item, index) => {
                  return (
                    <Col md={8} className="p-0">
                      <div className="m-0 p-16 mt-3 border-1 bColor-EFE3D7">
                        <div className="flex justify-between">
                          <div className="fs-16 lh-16 fc-292D32 family_outfit_medium_500">
                            {item?.medication_name}
                          </div>
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center cursor-pointer ..."
                          >
                            <div>
                              <Image
                                src={EditMedicine}
                                alt="icon"
                                onClick={() => handleAddMedicine(item, index)}
                              />
                            </div>
                            <div>
                              <Image
                                src={DeleteMedicine}
                                alt="icon"
                                onClick={() => handleDeleteMedicine(index)}
                              />
                            </div>
                          </Stack>
                        </div>
                        <Stack
                          direction="horizontal"
                          gap={5}
                          className="items-center pt-16"
                        >
                          <div className="fs-14 lh-16 fc-998A7B family_outfit_regular_400">
                            Form:
                            <span className="fs-16 pl-04 lh-16 fc-3C3C3C family_outfit_regular_400">
                              {item?.medicine_form}
                            </span>
                          </div>
                          <div className="fs-14 lh-16 fc-998A7B family_outfit_regular_400">
                            Dosage:
                            <span className="fs-16 pl-04 lh-16 fc-3C3C3C family_outfit_regular_400">
                              {item?.dosage}
                            </span>
                          </div>
                          <div className="fs-14 lh-16 fc-998A7B family_outfit_regular_400">
                            Duration:
                            <span className="fs-16 pl-04 lh-16 fc-3C3C3C family_outfit_regular_400">
                              {item?.duration}
                            </span>
                          </div>
                          <div className="fs-14 lh-16 fc-998A7B family_outfit_regular_400">
                            Substitution Allowed:
                            <span className="fs-16 pl-04 lh-16 fc-3C3C3C family_outfit_regular_400">
                              {item?.is_substitute ? 'Yes' : 'No'}
                            </span>
                          </div>
                        </Stack>
                      </div>
                    </Col>
                  );
                })}
              <Col md={8} className="p-0">
                <div className="m-0 pt-16">
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#375241"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 25px"
                    height="40px"
                    bgColor="transparent"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => handleAddMedicine()}
                  >
                    <img
                      src={AddIcon}
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                      className="me-2"
                    />
                    <FormattedMessage id="Add Medicine" />
                  </ReusableButton>
                </div>
              </Col>

              <Col md={8} className="p-0">
                <Stack
                  direction="horizontal"
                  gap={3}
                  className="items-center pt-24"
                >
                  <div className="fs-17 lh-21  fc-292D32 family_outfit_medium_500">
                    Advice
                  </div>
                  <div className="flex ">
                    <Image
                      src={EditMedicine}
                      alt="icon"
                      onClick={() => handleAdvice()}
                      className="cursor-pointer ..."
                    />
                  </div>
                </Stack>
              </Col>
              <Col md={8} className="p-0">
                <div className="fs-16 pt-16 fc-998A7B lh-201 family_outfit_regular_400">
                  {adviceTextShow}
                </div>
              </Col>
              <Col md={8} className="p-0">
                <div className="fs-17 lh-21 pt-24 fc-292D32 family_outfit_medium_500">
                  Follow Up Date
                </div>
              </Col>
              <Row>
                <Col md={4} className="p-0">
                  <div className="pt-12">
                    <LabelWithInput
                      type="date"
                      borderShow={'1px solid #EFE3D7'}
                      borderBottomShow={'1px solid #EFE3D7'}
                      value={followUpDate}
                      onChange={(e) => setFollowUpDate(e.target.value)}
                    />
                  </div>
                </Col>
              </Row>
              <Col md={8} className="p-0">
                <div className="fs-17 lh-21 pt-24 fc-292D32 family_outfit_medium_500">
                  Recommended Products
                </div>
              </Col>
              <Col md={8} className="p-0">
                <Row className="">
                  {showProductListItem &&
                    showProductListItem?.length > 0 &&
                    showProductListItem.map((item, index) => {
                      return (
                        <Col md={6} className="mt-3">
                          <div className="border-1 bColor-EFE3D7 p-8">
                            <Row className="g-2">
                              <Col md={3}>
                                <div>
                                  <Image
                                    src={item?.product_image}
                                    alt="icon"
                                    style={{ width: '100%' }}
                                  />
                                </div>
                              </Col>
                              <Col md={9}>
                                <div className="fs-14 lh-18 pt-8 fc-292D32 family_outfit_regular_400">
                                  {item?.product_name}
                                </div>
                                <div className="fs-14 lh-18 pt-04 fc-A4AAB2 family_outfit_regular_400">
                                  {item?.product_category_name}
                                </div>
                                <div className="flex justify-between pt-12">
                                  <div className="fs-16 lh-20  fc-292D32 family_outfit_semiBold_600">
                                    {`$ ${item?.product_price}`}
                                  </div>
                                  <div>
                                    <Image
                                      src={DeleteMedicine}
                                      alt="icon"
                                      className="cursor-pointer ..."
                                      onClick={() =>
                                        handleDeleteProductList(index)
                                      }
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      );
                    })}
                </Row>
              </Col>
              <Col md={8} className="p-0">
                <div className="m-0 pt-16">
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#375241"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 25px"
                    height="40px"
                    bgColor="transparent"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => handleAddProduct()}
                  >
                    <img
                      src={AddIcon}
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                      className="me-2"
                    />
                    <FormattedMessage id="Add Product" />
                  </ReusableButton>
                </div>
              </Col>

              <Col md={6} className="p-0 mt-2">
                <TabSwitch
                  label={'Repeat Prescription'}
                  tabs={switchInput}
                  selectedTabValue={isRepeatPrescription}
                  tranferData={(e, value) => setIsRepeatPrescription(value.id)}
                />
              </Col>

              {isRepeatPrescription && (
                <Col md={8} className="p-0">
                  <div className="fs-17 lh-21 pt-24 mb-1 fc-292D32 family_outfit_medium_500">
                    Repeat Notes
                  </div>
                  <LabelWithTextArea
                    placeholder={intl.formatMessage({ id: 'Write here...' })}
                    height="60"
                    multiline
                    name="repeatNotes"
                    Color={'#212426'}
                    padding={'8px'}
                    value={repeatNotes}
                    onChange={(e) => setRepeatNotes(e?.target?.value)}
                  />
                </Col>
              )}

              <Col md={12} className="p-0 mt-2 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="flex items-center"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="400"
                    padding="14px 55px"
                    height="40px"
                    bgColor="transparent"
                    brColor="#375241"
                    fontFamily="outfit_regular"
                    onClick={() => navigate(-1)}
                  >
                    <FormattedMessage id="Go Back" />
                  </ReusableButton>
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="500"
                    padding="14px 55px"
                    height="40px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !pendingReducer && handleCreateDetail();
                    }}
                    loading={pendingReducer}
                  >
                    <FormattedMessage id="Generate & Notify Patient" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <CommonModal
        padding={'24px'}
        width={'628px'}
        modalActive={medicineModal}
        innerContent={
          <div className="p-0 m-0">
            <Row className="p-0 m-0">
              <Col md={12} className="p-0 m-0">
                <div className="fs-24 fc-242E39 lh-3024 family_outfit_semiBold_600">
                  Add Medicine
                </div>
              </Col>
              <Col md={12} className="p-0 m-0">
                <div className="pt-16">
                  <LabelWithInput
                    label="Medicine"
                    placeholder="Medicine Name"
                    name="medication_name"
                    type="text"
                    value={formData?.medication_name}
                    onChange={(e) => handleInputChange(e, 'medication_name')}
                    errorText={
                      isError &&
                      isError?.medication_name?.error &&
                      isError?.medication_name?.errorMessage
                    }
                  />
                </div>
              </Col>
              <div className="pt-[30px]">
                <Row>
                  <Col md={4} className="p-0 m-0">
                    <LabelWithInput
                      label="Form"
                      placeholder="Form"
                      name="medicine_form"
                      type="text"
                      value={formData?.medicine_form}
                      onChange={(e) => handleInputChange(e, 'medicine_form')}
                      errorText={
                        isError &&
                        isError?.medicine_form?.error &&
                        isError?.medicine_form?.errorMessage
                      }
                    />
                  </Col>
                  <Col md={4} className="modal-size">
                    <LabelWithInput
                      label="Dosage"
                      placeholder="Dosage"
                      name="dosage"
                      type="text"
                      value={formData?.dosage}
                      onChange={(e) => handleInputChange(e, 'dosage')}
                      errorText={
                        isError &&
                        isError?.dosage?.error &&
                        isError?.dosage?.errorMessage
                      }
                    />
                  </Col>
                  <Col md={4} className="modal-size">
                    <LabelWithInput
                      label="Duration"
                      placeholder="Duration"
                      name="duration"
                      type="text"
                      value={formData?.duration}
                      onChange={(e) => handleInputChange(e, 'duration')}
                      errorText={
                        isError &&
                        isError?.duration?.error &&
                        isError?.duration?.errorMessage
                      }
                    />
                  </Col>
                </Row>
              </div>
              <div className="pt-16">
                <Row>
                  <Col md={6} className="mt-2">
                    <TabSwitch
                      label={'Substitution Allowed'}
                      tabs={switchInput}
                      selectedTabValue={formData?.is_substitute}
                      tranferData={(e, value) =>
                        handleCheckboxChange(e, 'is_substitute', value)
                      }
                    />
                  </Col>
                </Row>
              </div>
              <Col md={12} className="p-0 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center pt-16"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="400"
                    padding="14px 55px"
                    height="40px"
                    bgColor="transparent"
                    brColor="#375241"
                    fontFamily="outfit_regular"
                    onClick={() => handleCloseMedicine()}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="500"
                    padding="14px 55px"
                    height="40px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => handleSaveMedicine()}
                  >
                    <FormattedMessage id="Add" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />

      <CommonModal
        padding={'24px'}
        width={'694px'}
        modalActive={adviceModal}
        innerContent={
          <div>
            <Row>
              <Col md={12} className="p-0 m-0">
                <div className="fs-24 fc-242E39 lh-3024 family_outfit_semiBold_600">
                  Add Advice
                </div>
              </Col>
              <Col md={12} className="p-0">
                <div className="pt-16">
                  <LabelWithTextArea
                    placeholder={intl.formatMessage({ id: 'Write here...' })}
                    height="100"
                    multiline
                    name="bio"
                    Color={'#212426'}
                    padding={'8px'}
                    value={adviceText}
                    onChange={(e) => setAdviceText(e?.target?.value)}
                    errorText={
                      isError &&
                      isError?.adviceText?.error &&
                      isError?.adviceText?.errorMessage
                    }
                  />
                </div>
              </Col>
              <Col md={12} className="p-0 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center pt-16"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="400"
                    padding="14px 55px"
                    height="40px"
                    bgColor="transparent"
                    brColor="#375241"
                    fontFamily="outfit_regular"
                    onClick={() => handleCloseAdvice()}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="500"
                    padding="14px 55px"
                    height="40px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => handleAdviceShow()}
                  >
                    <FormattedMessage id="Done" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />

      <Dialog open={productModal} maxWidth="sm" fullWidth>
        <DialogContent>
          <Row className="m-0 p-0">
            <Col md={12} className="p-0 m-0">
              <div className="fs-24 fc-242E39 lh-3024 family_outfit_semiBold_600">
                Recommend a product
              </div>
            </Col>
            <Col md={12} className="p-0">
              <div className="pt-16">
                <LabelWithInput
                  // label="Search for product"
                  placeholder="Search for product"
                  name="providerName"
                  type="text"
                  borderShow={'1px solid #EFE3D7'}
                  borderRadius={'8px'}
                  value={searchInput}
                  onChange={(e) => handleSearchInput(e)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Image
                          src={SearchIcon}
                          alt="icon"
                          style={{ cursor: 'pointer' }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </Col>
            <div className="h-[72vh] overflow-y-auto">
              {productDetail &&
                productDetail?.length > 0 &&
                productDetail.map((item, index) => {
                  return (
                    <Col md={12} className="p-0">
                      <div className="pt-16">
                        <div
                          className="p-8 cursor-pointer ..."
                          style={{
                            border: showProductId.includes(item?.node?.id)
                              ? '2px solid #864629'
                              : '1px solid #EFE3D7',
                          }}
                          onClick={() => handleSelectProduct(item)}
                        >
                          <Row className="g-2">
                            <Col md={2}>
                              <div>
                                <Image
                                  src={item?.node?.featuredImage?.url}
                                  alt="icon"
                                  style={{ width: '100%' }}
                                />
                              </div>
                            </Col>
                            <Col md={10}>
                              <div className="flex justify-between pt-8">
                                <div className="fs-14 lh-18 fc-292D32 family_outfit_regular_400">
                                  {item?.node?.title}
                                </div>
                              </div>
                              <div className="fs-14 lh-18 pt-04 fc-A4AAB2 family_outfit_regular_400">
                                {item?.node?.category?.name}
                              </div>
                              {/* <div className="fs-16 lh-20 pt-12 fc-292D32 family_outfit_semiBold_600">
                              {`$ ${item?.node?.variants?.edges?.[0]?.node?.price}`}
                            </div> */}
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Col>
                  );
                })}
            </div>
            <Col md={12} className="p-0 flex justify-end">
              <Stack
                direction="horizontal"
                gap={2}
                className="items-center pt-16"
              >
                <ReusableButton
                  fullWidth={false}
                  variant="outlined"
                  color="#3C3C3C"
                  fontSize="14px"
                  fontWeight="400"
                  padding="14px 55px"
                  height="40px"
                  bgColor="transparent"
                  brColor="#375241"
                  fontFamily="outfit_regular"
                  onClick={() => handleCloseProduct()}
                >
                  <FormattedMessage id="Cancel" />
                </ReusableButton>
                <ReusableButton
                  fullWidth={false}
                  variant="outlined"
                  color="#F5F5F5"
                  fontSize="16px"
                  fontWeight="500"
                  padding="14px 55px"
                  height="40px"
                  bgColor="#375241"
                  brColor="#375241"
                  fontFamily="outfit_medium"
                  onClick={() => handleAddProductList()}
                >
                  <FormattedMessage id="Done" />
                </ReusableButton>
              </Stack>
            </Col>
          </Row>
        </DialogContent>
      </Dialog>

      <CommonModal
        padding={'24px'}
        width={'628px'}
        modalActive={diagnosisModal}
        innerContent={
          <div className="p-0 m-0">
            <Row className="p-0 m-0">
              <Col md={12} className="p-0 m-0">
                <div className="fs-24 fc-242E39 lh-3024 family_outfit_semiBold_600">
                  Add Diagnosis
                </div>
              </Col>
              <Col mg={12} className="p-0">
                <div className="pt-16">
                  <LabelWithInput
                    label="Diagnosis Name"
                    placeholder="Diagnosis Name"
                    name="diagnosis_finding"
                    type="text"
                    value={formValue?.diagnosis_finding}
                    onChange={(e) =>
                      handleInputDiagnosisChange(e, 'diagnosis_finding')
                    }
                    errorText={
                      isError &&
                      isError?.diagnosis_finding?.error &&
                      isError?.diagnosis_finding?.errorMessage
                    }
                  />
                </div>
              </Col>
              <Col md={12} className="p-0 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center pt-16"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="400"
                    padding="14px 55px"
                    height="40px"
                    bgColor="transparent"
                    brColor="#375241"
                    fontFamily="outfit_regular"
                    onClick={() => handleCloseDiagnosis()}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="500"
                    padding="14px 55px"
                    height="40px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => handleSaveDiagnosis()}
                  >
                    <FormattedMessage id="Save" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />
    </div>
  );
};

export default PendingDetail;
